export const ArrowRightIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 4.08008L15.52 10.6001C16.29 11.3701 16.29 12.6301 15.52 13.4001L9 19.9201"
                stroke="#292D32"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
